import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useMemo, useRef } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { BKJIcon } from '../index.js';
import { BKJCheckboxDisplay, BKJCheckboxInput } from '../BKJCheckbox/BKJCheckbox.styled.js';
import { BKJCheck } from '../BKJCheckbox/src/BKJCheck.js';
import { ListItemWrapper } from '../BKJListItem/BKJListItem.styled.js';
import { ListItemText, SubLabel } from '../common/ListItemBaseCSS/index.js';
import { CheckboxSlot, LabelWrapper } from './BKJCheckboxListItem.styled.js';
export const BKJCheckboxListItem = forwardRef((props, ref) => {
    const { onChange, name, subLabel, label, className, disabled = false, isTargeted = false, showPeopleIcon = false, selected, value, listItemVariant = 'LeftAlignAlternatingBackgroundColor', checkboxVariant = 'GreenSolid', ...rest } = props;
    const inputIdRef = useRef(`bkj-cbli-input-${uuidv4()}`);
    const labelIdRef = useRef(`bkj-cbli-label-${uuidv4()}`);
    const labelRef = useRef(null);
    const inputRef = useRef(null);
    const checked = useMemo(() => {
        if (Array.isArray(selected)) {
            return selected?.some((str) => String(str) === String(value));
        }
        else {
            return false;
        }
    }, [selected, value]);
    const handleInputChange = (event) => {
        if (!onChange)
            return;
        onChange({
            ...event,
            target: {
                ...event.target,
                checked: event.target.checked,
                name,
                value,
                label,
            },
        });
    };
    const handleWrapperClick = (e) => {
        if (disabled)
            return;
        if (labelRef.current?.contains(e.target))
            return;
        inputRef.current?.click();
    };
    return (_jsx(ListItemWrapper, { ...rest, variant: listItemVariant, className: className, checked: checked, disabled: disabled, isTargeted: isTargeted, ref: ref, onClick: handleWrapperClick, children: _jsxs(LabelWrapper, { htmlFor: inputIdRef.current, ref: labelRef, children: [_jsxs(CheckboxSlot, { children: [_jsx(BKJCheckboxInput, { ref: inputRef, type: "checkbox", id: inputIdRef.current, "aria-labelledby": labelIdRef.current, checked: checked, disabled: disabled, name: name, onChange: handleInputChange }), _jsx(BKJCheckboxDisplay, { "aria-hidden": "true", value: checked, disabled: disabled, variant: checkboxVariant, children: _jsx(BKJCheck, { variant: checkboxVariant, checked: checked, disabled: disabled }) })] }), showPeopleIcon && _jsx(BKJIcon, { iconName: "Group2", width: 16, height: 14, "aria-hidden": "true" }), _jsx(ListItemText, { id: labelIdRef.current, children: label }), subLabel && _jsx(SubLabel, { children: subLabel })] }) }));
});
//# sourceMappingURL=BKJCheckboxListItem.js.map